
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { TAccount } from "@/models/account";

@Component
export default class ConfirmIdentityPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: Object, required: true }) readonly account!: TAccount;

  showPopup = false;

  loading = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  sendCode() {
    this.$emit("send-code");
  }
}
